module.exports = __webpack_public_path__ + "8fc61e3b0b57f211eedccb30e76fe8e0.jpg";